import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';

import * as Types from 'types';
import { TabLink } from 'vault/components/TabLink';
import { setAddArtworkOpen } from 'features/playlists/actions';
import { ArtStreamArtworksSelectorContainer } from 'playlists/ArtStreamArtworksSelectorContainer';
import { VaultArtworksSelectorContainer } from 'playlists/VaultArtworksSelectorContainer';
import { WishlistArtworksSelectorContainer } from 'playlists/WishlistArtworksSelectorContainer';

type StateProps = {
  isAddArtworkOpen: boolean;
};

type DispatchProps = {
  setAddArtworkOpen: typeof setAddArtworkOpen;
};

type OwnProps = Types.Styleable;

type Props = StateProps & DispatchProps & OwnProps;

type State = {
  activeTabIndex: number;
};

class PlaylistArtworkSelector extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { activeTabIndex: 0 };
    this.onTabChange = this.onTabChange.bind(this);
  }

  onTabChange(activeTabIndex: number) {
    this.setState({ activeTabIndex });
  }

  render() {
    const { activeTabIndex } = this.state;
    const { isAddArtworkOpen } = this.props;
    const className = classNames(
      {
        'vault-artworks': true,
        'vault-artworks--popup': isAddArtworkOpen,
      },
      this.props.className,
    );

    return (
      <div className={className}>
        <div className='playlist-header mb-1'>
          {isAddArtworkOpen && (
            <div className='d-flex justify-content-end'>
              <button
                type='button'
                onClick={() => this.props.setAddArtworkOpen(false)}
                className='btn btn--medium btn--border-light mb-1 playlist-header__close'
              >
                Done
              </button>
            </div>
          )}
          <div className='d-flex justify-content-lg-between'>
            <TabLink
              onClick={this.onTabChange}
              index={0}
              activeIndex={activeTabIndex}
              className='mr-1 mr-lg-0'
            >
              Art Stream
            </TabLink>
            <TabLink
              onClick={this.onTabChange}
              index={1}
              activeIndex={activeTabIndex}
              className='mr-1 mr-lg-0'
            >
              Your Vault
            </TabLink>
            <TabLink
              onClick={this.onTabChange}
              index={2}
              activeIndex={activeTabIndex}
              className='mr-1 mr-lg-0'
            >
              Wishlist
            </TabLink>
          </div>
        </div>
        <SwipeableViews index={activeTabIndex} onChangeIndex={this.onTabChange}>
          <ArtStreamArtworksSelectorContainer />
          <VaultArtworksSelectorContainer />
          <WishlistArtworksSelectorContainer />
        </SwipeableViews>
      </div>
    );
  }
}

const mapStateToProps = (state: Types.RootState) => ({
  isAddArtworkOpen: state.playlists.isAddArtworkOpen,
});

const mapDispatchToProps = {
  setAddArtworkOpen,
};

export const PlaylistArtworkSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlaylistArtworkSelector);
